import { Typography } from "@material-ui/core";

import ErrorPage from "../../components/ErrorPage";

import DevicesIcon from "../../assets/img/devices-icon.png";

const SmallScreenPage = () => {
  return (
    <ErrorPage
      icon={<img src={DevicesIcon} alt="" />}
      title="Switch to bigger device"
      content={
        <>
          <Typography gutterBottom>
            For an optimal experience, you need to switch to a larger device.
            Efestra is not optimised to be used on devices smaller than tablets.
          </Typography>

          <Typography>The smallest recommended size is: 768px</Typography>
        </>
      }
    />
  );
};

export default SmallScreenPage;
